import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgButton, IgDialog, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { isDialogOpen, setDialog } from "@src/store/slices/global";
import { contactSupport } from "@src/utils/contactSupport";
import { carrierServices } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

export const StartShippingErrorDialog = () => {
  const isOpen = useSelector(isDialogOpen("startShippingError"));
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setDialog({ dialog: "startShippingError", open: false }));
  };

  return (
    <IgDialog
      title={"Unable to Start Shipping Test"}
      showDialog={isOpen}
      handleClose={handleClose}
      hideActions={true}
      rawContent={
        <Grid container direction={"column"} rowSpacing={2}>
          <Grid item>
            <IgTypography>
              We couldn't start your shipping experiment because you don't have
              Shopify's third-party carrier feature enabled. This feature is
              enabled by default for those on Shopify Advanced and Plus, and is
              available to merchants on the "Shopify" plan for either a monthly
              fee or by switching to yearly billing. You can request it by
              contacting Shopify support. Learn more{" "}
              <IgTypography
                igStyle={"linkNoBold"}
                onClick={() => {
                  openNewTab(carrierServices);
                }}
              >
                here
              </IgTypography>{" "}
              or{" "}
              <IgTypography
                igStyle={"linkNoBold"}
                onClick={() => {
                  contactSupport();
                }}
              >
                contact us
              </IgTypography>{" "}
              with any questions!
            </IgTypography>
          </Grid>
          <Grid item>
            <IgTypography>
              Once you've enabled third-party carriers, click "Resume" on your
              experiment again to launch it.
            </IgTypography>
          </Grid>
          <Grid container item direction={"row"} justifyContent={"flex-end"}>
            <IgButton onClick={handleClose} color={"secondary"}>
              Close
            </IgButton>
          </Grid>
        </Grid>
      }
    />
  );
};
